module.exports = __webpack_public_path__ + "static/media/abstract2.fe3ffc64.jpg";